import { Close } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React from 'react';
import { LegacyIconRenderer } from "../../helper/components/LegacyIconRenderer.js";
import { IconButton } from "../iconButton/IconButton.js";
import { Typography } from "../typography/Typography.js";
import styles from "./Banner.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Banner = ({
  className,
  children,
  onDismiss,
  dismissible = false,
  title,
  icon,
  iconSize,
  ...rest
}) => {
  const classes = classnames(styles.banner, {
    [styles.empty]: !children
  }, className);
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    ...rest,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.contentContainer,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.bannerIcon,
        children: icon && /*#__PURE__*/_jsx(LegacyIconRenderer, {
          icon: icon,
          size: iconSize ?? 30
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [/*#__PURE__*/_jsx(Typography, {
          className: styles.title,
          variant: "h4",
          children: title
        }), /*#__PURE__*/_jsx("div", {
          className: styles.text,
          children: children
        })]
      })]
    }), dismissible && /*#__PURE__*/_jsx(IconButton, {
      onClick: onDismiss,
      icon: Close,
      className: styles.dismissIcon,
      toolbar: true,
      tertiary: true
    })]
  });
};